import { MenuItem, MenuList, mergeClasses } from "@fluentui/react-components";
import React, { useMemo } from "react";

import { AppLeftBarSubMenuProps } from "./AppLeftBarSubMenu.types";
import { Link } from "react-router";
import { observer } from "mobx-react";
import { useAppLeftBarSubMenuStyles } from "./AppLeftBarSubMenu.styles";

const AppLeftBarSubMenuBase = (props: AppLeftBarSubMenuProps) => {
    const { subItems, matchedItem, onDismiss } = props;

    const classNames = useAppLeftBarSubMenuStyles();

    const renderMenuList = useMemo(
        (): React.ReactElement => (
            <>
                {subItems.map((subItem) => {
                    const isSubMenuMatched = subItem.displayName === matchedItem.subItemKey;
                    const className = isSubMenuMatched
                        ? mergeClasses(classNames.subMenuItem, classNames.selectedSubMenuItem)
                        : mergeClasses(classNames.subMenuItem);
                    return (
                        <MenuItem key={subItem.displayName} className={className}>
                            <Link
                                className={classNames.link}
                                to={subItem.routeName ?? ""}
                                onClick={onDismiss}
                                aria-label={subItem.description ? `${subItem.displayName}, ${subItem.description}` : subItem.displayName}
                            >
                                <div>{subItem.displayName}</div>
                            </Link>
                        </MenuItem>
                    );
                })}
            </>
        ),

        [classNames.link, classNames.selectedSubMenuItem, classNames.subMenuItem, matchedItem.subItemKey, onDismiss, subItems]
    );

    return <MenuList>{renderMenuList}</MenuList>;
};

export const AppLeftBarSubMenu = observer(AppLeftBarSubMenuBase);
